// extracted by mini-css-extract-plugin
module.exports = {"action":"FileAction_action__2cLQ6","menu":"FileAction_menu__neqXN","container":"FileAction_container__hWpR7","actionItem":"FileAction_actionItem__3AOle"};